import UspView from "./uspView";

const UspLayout = () => {
    return (
        <>
            <UspView />
        </>
    );
}

export default UspLayout;